// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F9Ps9","rootNoMargin":"styles_rootNoMargin__h6bfH"};